import { render, staticRenderFns } from "./NewsletterItem.vue?vue&type=template&id=6c22b322&scoped=true&"
import script from "./NewsletterItem.vue?vue&type=script&lang=js&"
export * from "./NewsletterItem.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterItem.vue?vue&type=style&index=0&id=6c22b322&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22b322",
  null
  
)

export default component.exports